import { useLocation, useHistory, Redirect } from 'react-router-dom';
import { EmbeddedContentPage } from '../components/EmbeddedContentPage';
import { Paths } from '../constants/Paths';
import { jsx as _jsx } from "react/jsx-runtime";
export function PayInvoicePage() {
  const location = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(location.search);
  const paymentUrl = params.get('url');
  const invoiceId = params.get('invoiceId');
  if (!paymentUrl) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: Paths.INVOICES
    });
  }
  return /*#__PURE__*/_jsx(EmbeddedContentPage, {
    src: paymentUrl,
    title: "Pay Invoice",
    breadcrumbs: [{
      label: 'payInvoice.breadcrumb.invoices',
      href: Paths.INVOICES
    }, {
      label: 'payInvoice.breadcrumb.payInvoice'
    }],
    subscreen: "pay-invoice",
    onMessage: msg => {
      if (msg.payload.type === 'SUCCESS' || msg.payload.type === 'SUCCESS_WITH_REDIRECT') {
        const successParams = new URLSearchParams();
        successParams.set('paymentSuccess', 'true');
        if (invoiceId) {
          successParams.set('paidInvoiceId', invoiceId);
        }
        history.push(`${Paths.INVOICES}?${successParams.toString()}`);
      }
    }
  });
}